import moment from "moment";
import "moment/min/locales";
import "moment/src/locale/fr";
moment.locale("fr");

export default moment;
